// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d876d9f0","457":"97510fde"}[chunkId] + ".chunk.js";
};